<table class="reassignmentPage_table" *ngIf="customers.length">
    <thead>
      <tr>
        <th></th>
        <th>{{"asm.order.reassignment.id" | translate}}</th>
        <th>{{"asm.order.reassignment.name" | translate}}</th>
        <th>{{"asm.order.reassignment.email" | translate}}</th>
        <th>{{"asm.order.reassignment.tel" | translate}}</th>
        <th>{{"asm.order.reassignment.address" | translate}}</th>
      </tr>
    </thead>
    <tbody>
    <tr class="a-person" *ngFor="let customer of  customers, let i = index; trackBy: getIdTracking" (click)="selectCustomer(customer)">
      <td>
        <div class="engi-radio-wrapper">
          <input type="radio" name="customerId" [checked]="selectedCustomer === customer" [id]="'customer'+i">
          <label [for]="'customer'+i" ></label>
        </div>
      </td>
      <td>{{customer.uid}}</td>
      <td>{{customer.name}}</td>
      <td>{{customer.email}}</td>
      <td>{{customer.tel}}</td>
      <td>
          {{customer.street}} {{customer.apartment}}
          <br>{{customer.postalCode}} {{customer.town}}
      </td>
    </tr>
    </tbody>
  </table>
  <p class="no-results" *ngIf="!customers.length">{{'asm.no.results' | translate}}</p>
